import React from "react";
import styles from "./AboutUs.module.scss";
import Navbar from "../Navbar";
import loveDoctor from "../../assets/Love Doctor.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import doctor from "../../assets/doctor tron.png";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import Footer from "../Footer";

const AboutUs = () => {
  return (
    <div className={styles.aboutUsMainDiv}>
      <Navbar />
      <div className={styles.aboutUsBody}>
        <Typography variant="h5">About Us</Typography>
        <Grid
          container
          spacing={2}
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Grid item sm={12} md={6} className={styles.leftSide}>
            <Typography variant="h4">
              Hi. We’re <br /> Tron Healthcare. <br /> We’re here to simplify
              OPD healthcare
            </Typography>
            <Typography variant="h6">
              We’re on a mission to make quality OPD healthcare simple,
              affordable, and within reach for everyone. By partnering with a
              trusted network of experienced doctors, we ensure patients receive
              timely, professional care—without the hassle or high costs of
              traditional systems.
            </Typography>
          </Grid>
          <Grid item sm={12} md={6} className={styles.rightSide}>
            <Box className={styles.headimagebox}>
              <img
                className={styles.headimage}
                // style={{ width: "100%" }}
                src={loveDoctor}
                alt="OPD-healthcare-service"
              />
            </Box>
          </Grid>
        </Grid>

        {/* *************Why patients choose us*************** */}

        <Box className={styles.why_patients_choose_tron}>
          {/* Text Section */}
          <Typography
            variant="h5"
            className={styles.why_patients_choose_tron__title}
          >
            Why Patients Choose Us ?
          </Typography>
          <Box className={styles.content}>
            <Box className={styles.why_choose_list}>
              <List className={styles.list}>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon className={styles.why_choose_tron__icon} />
                  </ListItemIcon>
                  <ListItemText primary="600+ Expert Doctors in Delhi/NCR – Consult with experienced, verified healthcare providers across specialties." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon className={styles.why_choose_tron__icon} />
                  </ListItemIcon>
                  <ListItemText primary="Save on OPD Care – Enjoy discounts on consultations, diagnostics, and treatments." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon className={styles.why_choose_tron__icon} />
                  </ListItemIcon>
                  <ListItemText primary="Preventive Health Packages – Affordable check-ups to catch issues early and stay ahead." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircleIcon className={styles.why_choose_tron__icon} />
                  </ListItemIcon>
                  <ListItemText primary="Hassle-Free Booking – Quick appointments, transparent pricing, no hidden costs." />
                </ListItem>
              </List>
            </Box>

            {/* Doctor Image */}
            <Box className={styles.why_choose_tron__image}>
              <img src={doctor} alt="Doctor illustration" />
            </Box>
          </Box>
        </Box>

        <Box className={styles.joinTronBox}>
          <Typography variant="h3">Join the Tron.Health Network</Typography>
          <Typography varient="h4" className={styles.content}>
            Whether you’re a patient looking for affordable OPD healthcare or
            a doctor interested in joining our network, we’re here to help.
          </Typography>
          <Typography className={styles.getInTouch}>
            <span>Get in touch:</span> support@tron.health
          </Typography>
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
